<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "4rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill-rule="evenodd" d="M12.273 12.273a1.5 1.5 0 012.121 0l34.773 34.772V24a1.5 1.5 0 013 0v26.667a1.5 1.5 0 01-1.5 1.5H24a1.5 1.5 0 010-3h23.045L12.273 14.394a1.5 1.5 0 010-2.121z"/></svg>